import { useEffect, useState } from "react";
import type { DailyData } from "./daily";

export type DailyState =
  | { status: "loading" }
  | { status: "ready"; data: DailyData }
  | { status: "error"; message: string };

export function useDaily(): DailyState {
  const [state, setState] = useState<DailyState>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    fetch("/data/daily/daily.json")
      .then((r) => {
        if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
        return r.json();
      })
      .then((data: DailyData) => {
        if (!cancelled) setState({ status: "ready", data });
      })
      .catch((e: unknown) => {
        if (!cancelled) {
          setState({
            status: "error",
            message: e instanceof Error ? e.message : String(e),
          });
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
